var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSmartList',{ref:"app-smart-list",attrs:{"breadcrumbData":_vm.breadcrumbData,"accessRights":_vm.accessRights,"filters":_vm.filters,"actions":_vm.actions,"tableHeaders":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }